var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserDashboard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 46,
    viewBox: "0 0 54 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_9711_92)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9 16.2857C13.4372 16.2857 15.5 13.8513 15.5 10.8571C15.5 7.86295 13.4372 5.42857 10.9 5.42857C8.36281 5.42857 6.3 7.86295 6.3 10.8571C6.3 13.8513 8.36281 16.2857 10.9 16.2857ZM43.1 16.2857C45.6372 16.2857 47.7 13.8513 47.7 10.8571C47.7 7.86295 45.6372 5.42857 43.1 5.42857C40.5628 5.42857 38.5 7.86295 38.5 10.8571C38.5 13.8513 40.5628 16.2857 43.1 16.2857ZM45.4 19H40.8C39.535 19 38.3922 19.6022 37.5584 20.5777C40.455 22.4522 42.5106 25.8366 42.9562 29.8571H47.7C48.9722 29.8571 50 28.6442 50 27.1429V24.4286C50 21.4344 47.9372 19 45.4 19ZM27 19C31.4491 19 35.05 14.7504 35.05 9.5C35.05 4.24955 31.4491 0 27 0C22.5509 0 18.95 4.24955 18.95 9.5C18.95 14.7504 22.5509 19 27 19ZM32.52 21.7143H31.9234C30.4284 22.5625 28.7681 23.0714 27 23.0714C25.2319 23.0714 23.5787 22.5625 22.0766 21.7143H21.48C16.9087 21.7143 13.2 26.0911 13.2 31.4857V33.9286C13.2 36.1763 14.7453 38 16.65 38H37.35C39.2547 38 40.8 36.1763 40.8 33.9286V31.4857C40.8 26.0911 37.0912 21.7143 32.52 21.7143ZM16.4416 20.5777C15.6078 19.6022 14.465 19 13.2 19H8.6C6.06281 19 4 21.4344 4 24.4286V27.1429C4 28.6442 5.02781 29.8571 6.3 29.8571H11.0366C11.4894 25.8366 13.545 22.4522 16.4416 20.5777Z",
    fill: "#333"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 10.8571C15 13.656 13.0866 15.7857 10.9 15.7857C8.71338 15.7857 6.8 13.656 6.8 10.8571C6.8 8.05826 8.71338 5.92857 10.9 5.92857C13.0866 5.92857 15 8.05826 15 10.8571ZM47.2 10.8571C47.2 13.656 45.2866 15.7857 43.1 15.7857C40.9134 15.7857 39 13.656 39 10.8571C39 8.05826 40.9134 5.92857 43.1 5.92857C45.2866 5.92857 47.2 8.05826 47.2 10.8571ZM43.3972 29.3571C42.8711 25.6256 40.9918 22.4398 38.3278 20.4999C39.0245 19.8647 39.8817 19.5 40.8 19.5H45.4C47.5866 19.5 49.5 21.6297 49.5 24.4286V27.1429C49.5 28.4489 48.6216 29.3571 47.7 29.3571H43.3972ZM34.55 9.5C34.55 14.5551 31.0985 18.5 27 18.5C22.9015 18.5 19.45 14.5551 19.45 9.5C19.45 4.44486 22.9015 0.5 27 0.5C31.0985 0.5 34.55 4.44486 34.55 9.5ZM27 23.5714C28.8204 23.5714 30.5247 23.06 32.0539 22.2143H32.52C36.7407 22.2143 40.3 26.2864 40.3 31.4857V33.9286C40.3 35.981 38.9041 37.5 37.35 37.5H16.65C15.0959 37.5 13.7 35.981 13.7 33.9286V31.4857C13.7 26.2864 17.2593 22.2143 21.48 22.2143H21.9466C23.4814 23.0596 25.1788 23.5714 27 23.5714ZM13.2 19.5C14.1183 19.5 14.9755 19.8647 15.6722 20.4999C13.008 22.4399 11.1285 25.6258 10.5963 29.3571H6.3C5.37838 29.3571 4.5 28.4489 4.5 27.1429V24.4286C4.5 21.6297 6.41338 19.5 8.6 19.5H13.2Z",
    stroke: "#333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_9711_92",
    x: 0,
    y: 0,
    width: 54,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_9711_92"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_9711_92",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserDashboard);
export default __webpack_public_path__ + "static/media/userDashboard.c5485a05d88506faea302793f6cb24e6.svg";
export { ForwardRef as ReactComponent };